import { fdtInstruction } from "@constants/instructionConstants";
import { virtualAssistanceFDTConfig } from "@constants/virtualAssistanceConstants";
import {
  AvailablePreTestConfigurationOptions,
  TestType,
  EyeType,
  AvailableProgressPageTestConfigurationOptions,
  TestConfiguration,
  TestCategory,
  WaitDuration,
  TestProgressConfiguration,
  TestUIConfiguration,
} from "types/testTypes";
import {
  CATEGORY_VERSION_MAP,
  FEATURE_VERSION_MAP,
  TEST_TYPE_VERSION_MAP,
} from "../versionConstants";
import {
  AVAILABLE_EYE_OPTIONS_MONOCULAR,
  AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS,
  CALIBRATION_TOGGLE_OPTION_NEW_APK,
} from "../configurationHelperConstants";

export const availableFDTTestConfigurationOptions: AvailablePreTestConfigurationOptions = {
  testTypes: {
    configurationFieldName: "testType",
    choices: [
      { validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.C_20_1], value: TestType.C_20_1 },
      { validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.C_20_5], value: TestType.C_20_5 },
      { validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.N_30_1], value: TestType.N_30_1 },
      { validSinceVersion: TEST_TYPE_VERSION_MAP[TestType.N_30_5], value: TestType.N_30_5 },
    ],
    isMandatory: true,
    validSinceVersion: CATEGORY_VERSION_MAP[TestCategory.FDT],
  },
  eyeConfigurationOptions: {
    ...AVAILABLE_EYE_OPTIONS_MONOCULAR,
    pauseOnFocusLostOption: {
      configurationFieldName: "autoPauseForGaze",
      choices: null,
      validSinceVersion: FEATURE_VERSION_MAP["fdtGazeAutoPause"],
    },
    toggleCalibrationOption: { ...CALIBRATION_TOGGLE_OPTION_NEW_APK },
  },
  languageOptions: null,
  virtualAssistantOptions: { ...AVAILABLE_VIRTUAL_ASSISTANT_OPTIONS },
  testSpeedOptions: null,
};

export const availableFDTTestProgressConfigurationOptions: AvailableProgressPageTestConfigurationOptions =
  {
    eyeConfigurationOptions: {
      eyeTypes: null,
      toggleCalibrationOption: null,
      pauseOnFocusLostOption: {
        configurationFieldName: "autoPauseForGaze",
        choices: null,
        validSinceVersion: FEATURE_VERSION_MAP["fdtGazeAutoPause"],
      },
      toggleTwoScreenFixationOption: null,
    },
  };

export const fdtTestConfiguration: TestConfiguration = {
  name: TestCategory.FDT,
  testType: TestType.C_20_1,
  eyeConfiguration: {
    eyeType: EyeType.RightEye,
    isCalibrationNeeded: true,
    autoPauseForGaze: true,
    isTwoScreenFixationEnabled: true,
    isBackToBackEyeTest: false,
  },
  testSpeed: WaitDuration.Standard,
  testLanguage: null,
  virtualAssistanceConfig: virtualAssistanceFDTConfig,
  isPressToStartEnabled: true,
  extraData: {
    constants: {
      initialContrast: 0.5012,
      secondContrast: 0.3981,
      thirdContrast: 1.0,
    },
  },
};

export const defaultFDTProgressConfiguration: TestProgressConfiguration = {
  eyeConfiguration: {
    autoPauseForGaze: true,
  },
};

export const fdtUIConfiguration: TestUIConfiguration = {
  showProgressBar: true,
  instructions: fdtInstruction,
  isConfigSavePermitted: true,
};
